import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from './apiRequest';

export interface ILocalityRentalReviewsAggregations {
  reviews_count: number;
  max_score: number;
  min_score: number;
  avg_score: number;
}
export const getLocalityRentalReviewsAggregations = ({
  lat,
  lng,
  localityType,
  regionCode,
}: {
  lat: number;
  lng: number;
  localityType: string;
  regionCode: string;
}) => {
  if (lng && lat) {
    const url = `${getCoreApi()}/aggregate-reviews-for-locality?lat=${lat}&lng=${lng}&locality_type=${localityType}&regionCode=${regionCode}`;
    return apiRequest<ILocalityRentalReviewsAggregations>({ url });
  }
  return null;
};
